/* eslint-disable react/prop-types */
import React from 'react'
import { useNavigate } from 'react-router-dom'
import './style.css'
import LogoTop from './../../img/лого.png'
import { NavLink } from 'react-router-dom'
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai'
import ScrollToForm from './../../Helper/scroll/scrollForm'


const Navbar = ({
  handleNavLinkClick,
  nav,
  setNav,
  scrollToContactsFunc,
  navbarRef,
}) => {
  const navigate = useNavigate()
  const scrollToFormFunc = ScrollToForm(navigate)

  const activeLink = 'nav-item_link nav-item_link--active'
  const normalLink = 'nav-item_link '
const emailAddress = 'info@freesunpro.com'
  

  return (
    <header className="header center-footer" ref={navbarRef}>
      <NavLink to="/">
        <img
          onClick={() => handleNavLinkClick('/')}
          className="header-logo"
          src={LogoTop}
          alt=""
        />
      </NavLink>

      <nav className="nav">
        <ul className={nav ? ['nav-list', 'active'].join(' ') : ['nav-list']}>
          <NavLink
            to="/information-about-the-school"
            className={({ isActive }) => (isActive ? activeLink : normalLink)}
          >
            <li
              className="nav-item"
              onClick={() =>
                handleNavLinkClick('/information-about-the-school')
              }
            >
              О нас
            </li>
          </NavLink>

          <li
            className="nav-item"
            onClick={() => handleNavLinkClick('/', 'courses')} 
          >
            Образовательная программа
          </li>
          <NavLink
            to="/Club-Free-Sun"
            className={({ isActive }) => (isActive ? activeLink : normalLink)}
          >
            <li onClick={() => handleNavLinkClick('/Club-Free-Sun')}>
              Клуб Free Sun
            </li>
          </NavLink>
          <NavLink
            to="/Gold-Bonus"
            className={({ isActive }) => (isActive ? activeLink : normalLink)}
          >
            <li
              onClick={() => handleNavLinkClick('/Gold-Bonus')}
              className="nav-item"
            >
              Золотой бонус
            </li>
          </NavLink>
          <NavLink to="/" >
            <li
              onClick={() => handleNavLinkClick('/', 'courses')}
              className="nav-item"
            >
              Блог
            </li>
          </NavLink>
          <NavLink
            to="/News"
            onClick={handleNavLinkClick}
            className={({ isActive }) => (isActive ? activeLink : normalLink)}
          >
            <li className="nav-item">Новости</li>
          </NavLink>

          <li
            className="nav-item nav-item-none"
            onClick={() => scrollToContactsFunc('footer')}
          >
            Контакты
          </li>
          <div className="contacts">
            <a className="nav-item" href="tel:+79315884966">
              +7 931 588 49 66
            </a>

            <a className="nav-item" href={`mailto:${emailAddress}`}>
              info@freesunpro.com
            </a>
            <p className="nav-item">Москва ул.Верхние Поля д. 10 пом. 113</p>
          </div>
        </ul>

        <div onClick={() => setNav(!nav)} className="mobile-btn">
          {nav ? (
            <AiOutlineClose color="white" size={30} />
          ) : (
            <AiOutlineMenu color="white" size={30} />
          )}
        </div>
      </nav>

      <button className="header-btn" onClick={scrollToFormFunc}>
        Получить консультацию
      </button>
    </header>
  )
}

export default Navbar
